import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { PAYMENT_METHOD } from '../enums';

@Pipe({
  name: 'paymentMethod'
})
export class PaymentMethodPipe extends EnumConverter implements PipeTransform {
  enumeration = PAYMENT_METHOD;
}
